<template>
  <NuxtLinkLocale prefetch :to="'/blog/' + href">
    <section
      class="space-y-6 aspect-square md:max-w-[282px] rounded-[30px] overflow-hidden relative"
    >
      <!-- Image -->
      <V2FileRenderer
        custom-class="bg-[#F6F5F4] aspect-square w-full md:h-[282px] object-cover"
        :image-url="imageUrl"
      />

      <!-- Gradient -->
      <div
        class="absolute bottom-0 left-0 w-full h-full bg-gradient-to-t from-[rgba(0,0,0,0.7)] via-transparent to-transparent z-5"
      />

      <!-- Content -->
      <article class="absolute bottom-0 z-10 w-full text-white p-3">
        <!-- Title -->
        <h2 class="text-[36px] truncate leading-[50px] pt-[5px] px-1 font-bold">
          {{ title }}
        </h2>

        <!-- Divider -->
        <div class="border-border-divider border-b" />

        <!-- Date -->
        <div
          class="text-[16px] font-light truncate leading-[24px] px-1 pt-[12px] flex items-center gap-1"
        >
          <Icon name="calendar" />
          {{ formatDate(publishDatetime ?? '') }}
        </div>
      </article>
    </section>
  </NuxtLinkLocale>
</template>

<script lang="ts" setup>
import dayjs from 'dayjs'

const props = defineProps<{
  title: string
  imageUrl: string
  href: string
  subtitle: string
  publishDatetime: string
  lang: string
}>()

const getThaiMonth = (month: string) => {
  const months: Record<string, string> = {
    January: 'มกราคม',
    February: 'กุมภาพันธ์',
    March: 'มีนาคม',
    April: 'เมษายน',
    May: 'พฤษภาคม',
    June: 'มิถุนายน',
    July: 'กรกฎาคม',
    August: 'สิงหาคม',
    September: 'กันยายน',
    October: 'ตุลาคม',
    November: 'พฤศจิกายน',
    December: 'ธันวาคม'
  }
  return months[month] || month
}

const formatDate = (dateString: string) => {
  const date = dayjs(dateString)
  const day = date.date()
  const year = props.lang === 'th' ? date.year() + 543 : date.year()
  const month =
    props.lang === 'th'
      ? getThaiMonth(date.format('MMMM'))
      : date.format('MMMM')
  if (props.lang === 'th') {
    return `${day} ${month} ${year}`
  } else {
    return ` ${month} ${day} , ${year}`
  }
}
</script>
